import { TermlyPolicyPage } from '../components/legal/TermlyPolicyPage';

const TERMLY_POLICY_ID = 'dfea7c63-0276-48bc-a658-28dbbdc567fb';

export function DisclaimerPage() {
  return (
    <TermlyPolicyPage
      policyId={TERMLY_POLICY_ID}
      title="Disclaimer"
      description="Important legal notices and limitations for using Filmple."
    />
  );
}
